const list = {
  total: 4,
  list: [
    {
      id: 1,
      a: 1,
      b: 5,
      c: 6,
      country: 'china',
      province: 'guangzhou',
      city: 'shenzhen'
    },
    {
      id: 2,
      a: 4,
      b: 7,
      c: 11,
      country: 'china',
      province: 'shandong',
      city: 'jinan'
    },
    {
      id: 3,
      a: 2,
      b: 3,
      c: 5,
      country: 'japan',
      province: 'fukushima',
      city: 'fukushima-shi'
    },
    {
      id: 4,
      a: 10,
      b: 2,
      c: 12,
      country: 'china',
      province: 'guangzhou',
      city: 'shenzhen'
    },
    {
      id: 5,
      a: 8,
      b: 3,
      c: 11,
      country: 'japan',
      province: 'kumamoto',
      city: 'yatsushiro-shi'
    }
  ]
}

export default { list }



// WEBPACK FOOTER //
// ./examples/mock/item.js